/* import __COLOCATED_TEMPLATE__ from './path-analysis.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();